import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCustomCodeIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17 17L22 12L17 7M7 7L2 12L7 17M14 3L10 21",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCustomCodeIcon;
